module.exports = __webpack_public_path__ + "img/sport-crossfit.029d7b05.jpg";